/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getUser, fetchLoggedInUser } from 'src/user';
import {
  fetchFIConsentTypes,
  addFIConsentType,
  updateFIConsentType,
  deleteFIConsentType,
  getFIConsentTypes,
} from 'src/financial-institution';
import { signOut, getToken } from '../index.js';

class Dummy extends Component {
  async componentDidMount() {
    const { token, fetchLoggedInUser } = this.props;

    if (!token.isEmpty()) {
      await fetchLoggedInUser();

      const { user, fetchFIConsentTypes } = this.props;

      if (user.financialInstitutionId) {
        fetchFIConsentTypes(user.financialInstitutionId);
      }
    }
  }

  handleLogoutClick = () => {
    const { signOut } = this.props;
    signOut();
  };

  handleAdd = () => {
    const { addFIConsentType, user } = this.props;

    addFIConsentType({
      financialInstitutionId: user.financialInstitutionId,
      name: 'Test Consent Type',
      longDescription: 'Lorem ipsum long',
      shortDescription: 'Lorem ipsum short',
      isBackgroundCheck: false,
      isSolventBackgroundCheck: false,
    });
  };

  handleEdit = () => {
    const { updateFIConsentType, user } = this.props;

    updateFIConsentType({
      financialInstitutionId: user.financialInstitutionId,
      consentTypeId: 16,
      name: 'Test Consent Type - Updated',
      longDescription: 'Lorem ipsum long - Updated',
      shortDescription: 'Lorem ipsum short - Updated',
      isBackgroundCheck: false,
      isSolventBackgroundCheck: false,
    });
  };

  handleDelete = () => {
    const { deleteFIConsentType, user } = this.props;

    deleteFIConsentType({
      financialInstitutionId: user.financialInstitutionId,
      consentTypeId: 17,
    });
  };

  render() {
    const { consentTypes } = this.props;

    return (
      <div style={{ padding: '25px' }}>
        <b>Account</b>
        <br />
        <pre style={{ maxHeight: '800px' }}>
          {JSON.stringify(consentTypes.items, undefined, 2)}
        </pre>
        <br />
        <button onClick={this.handleAdd}>Add consent type</button>&nbsp;&nbsp;
        <button onClick={this.handleEdit}>Edit consent type</button>&nbsp;&nbsp;
        <button onClick={this.handleDelete}>Delete consent type</button>
        &nbsp;&nbsp;
        <br />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  token: getToken(state),
  user: getUser(state),
  consentTypes: getFIConsentTypes(state),
});

export const DummyPage = connect(mapStateToProps, {
  signOut,
  fetchLoggedInUser,
  fetchFIConsentTypes,
  addFIConsentType,
  updateFIConsentType,
  deleteFIConsentType,
})(Dummy);
